import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { Subject } from 'rxjs';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  FormGroup,
  FormControl,
  Validators
} from '@angular/forms';

import { FileItem, FileLikeObject, FileUploader } from 'ng2-file-upload';
import { ApiService } from '../services/api.service';

import { IProduct } from '../interfaces/product';
import { ProductService } from '../services/product.service';
import { IShowcase } from '../interfaces/showcase';
import { ShowcaseService } from '../services/showcase.service';
import { CategoryService } from '../services/category.service';
import { ActivatedRoute } from '@angular/router';
import { ICategory } from '../interfaces/category';
import { HelperService } from '../services/helper.service';
import { ISearch } from '../interfaces/search';
import { AppSettings } from '../appSettings';
import { AppFormat } from '../appFormat';
import { NavigationService } from '../services/navigation-service.service';

@Component({
  selector: 'app-showcase-register',
  templateUrl: './showcase-register.component.html',
  styleUrls: ['./showcase-register.component.scss'],
  host: { 'class': 'wrapper-showcase' },
  encapsulation: ViewEncapsulation.None
})
export class ShowcaseRegisterComponent implements OnInit {

  @ViewChild('listProducts') listProducts: ElementRef<HTMLDivElement>;

  public origem = [{ label: 'Produtos específicos', id: 'P' }, { label: 'Produtos de categorias inteiras', id: 'C' }]

  public categorias = []

  private _id: number
  public showcase: IShowcase
  public imageCapa: string

  public showcaseFrm: FormGroup

  public nome: FormControl
  public tipo: FormControl

  public mais_vendidos: FormControl
  public oferta: FormControl

  public titulo_banner: FormControl

  public changeDetail: boolean = false
  public loading: boolean = false
  public productChange: boolean = false
  public showModal: boolean = false
  public openModal: boolean = false
  private query
  private querySelected

  public strSearch = ''
  public flMarca = null
  public flCategoria = null

  public searchTerm$ = new Subject<ISearch>()
  public page: number = 1
  public pageSelected: number = 1

  //public produtos: IProduct[]

  public produtos: IProduct[]
  public products: IProduct[]
  public produtosSelected: IProduct[]
  public loadingProducts: boolean = false
  public loadingSelectedProducts: boolean = false

  public arrowRight: boolean = false
  public arrowLeft: boolean = false
  private moveList: number = 0

  public brands: any[]
  public categories: ICategory[]

  public isOffer: boolean = false
  public promotion: number = 0

  public uploader:FileUploader;
  public hasBaseDropZoneOver:boolean = false;

  public imageBanner: string
  public uploader_banner:FileUploader;
  public hasBaseDropZoneBannerOver:boolean = false;

  public labelCategories = 'Selecionar as categorias'

  public num_uploads: number

  public select_program: FormControl

  public dt_start: FormControl
  public dt_expired: FormControl
  public diasemana: FormControl

  public diasemana_monday: FormControl
  public diasemana_tuesday: FormControl
  public diasemana_wednesday: FormControl
  public diasemana_thursday: FormControl
  public diasemana_friday: FormControl
  public diasemana_saturday: FormControl
  public diasemana_sunday: FormControl

  public randomico: FormControl
  public carrossel: FormControl

  constructor(private _productService: ProductService,
    private _showcaseService: ShowcaseService,
    private _route: ActivatedRoute,
    private _helperService: HelperService,
    private _categoryService: CategoryService,
    private _apiService: ApiService, private navigation: NavigationService
  ) {
    this.produtos = []
    this.products = []
    this.produtosSelected = []
    this.categories = []
    this.brands = []

    this.query = { page: this.page }
    this.querySelected = { page: this.pageSelected, in_idcategoria: [] }

    this._productService.searchProducts(this.searchTerm$).subscribe(res => {
      this.products = this.checkListProducts(this.page > 1 ? this.products.concat(res.data) : res.data)

      this.loadingProducts = false

      //console.log(this.query);
      this.page = this.page + 1
    })


    /**
     *
     * envio da capa da vitrine
     *
     */

    this.uploader = new FileUploader({
      url: _apiService.API_PATH,
      allowedFileType: ['image'],
      allowedMimeType: [
        'image/jpeg',
        'image/png',
        'image/webp',
        'image/gif'
      ],
      maxFileSize: (1048576 * 2),
      filters: [{
        name: 'imageFilter',
        fn: function(item /*{File|FileLikeObject}*/, options) {
            var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
            return '|jpg|png|jpeg|gif|webp|'.indexOf(type) !== -1;
        }
      }]
    })

    this.uploader.onAfterAddingFile = f => {
      f.withCredentials = false;

      if (this.uploader.queue.length > 1) {
        this.uploader.removeFromQueue(this.uploader.queue[0]);
      }

      this.imageCapa = ''
      this.onChangeDetail()
    }

    this.uploader.onBeforeUploadItem = (fileItem: any) => {
        fileItem.options.additionalParameter = {
          idvitrine: this.showcase.idvitrine
        };
    }

    this.uploader.onCompleteItem = (item:any, response:any, status:number, headers:any) => {
      if (status == 200) {
        var responsePath = JSON.parse(response);
        if (responsePath['success']) {
          this.showcase.capa = responsePath['capa']

          this.imageCapa = AppSettings.URL_IMG_ESTABELECIMENTO + this.showcase.idestabelecimento + '/vitrine/' + this.showcase.capa
        }
      }
    }

    this.uploader.onCompleteAll = () => {
      this.uploader.clearQueue()
      this.num_uploads -= 1

      console.log('uploader', this.num_uploads)

      if (this.num_uploads <= 0) {
        this.saveComplete()
      }
    }

    this.uploader.onErrorItem = (item:FileItem, response:any, status:any, headers:any) => {
      //console.log(item)

      item.remove()

      Swal.fire("Ops!", "Ocorreu um erro ao processar a imagem, verifique se a imagem está correta! Se é um arquivo válido de imagem (png, jpg, webp, gif) com no máximo 2 MB de tamanho", "error")
    }

    this.uploader.onWhenAddingFileFailed = function (item: FileLikeObject, filter: any, options: any) {
      //console.log(item);
      //console.log(filter);
      //console.log(options);

      Swal.fire("Ops!", "O arquivo selecionado não é válido, verifique se é um arquivo de imagem (png, jpg, webp, gif) com no máximo 2 MB de tamanho!", "error")
    }

    /**
     *
     * IMAGE BANNER PAGINA VITRINE
     *
     */
    this.uploader_banner = new FileUploader({
      url: _apiService.API_PATH,
      allowedFileType: ['image'],
      allowedMimeType: [
        'image/jpeg',
        'image/png',
        'image/webp',
        'image/gif'
      ],
      maxFileSize: (1048576 * 2),
      filters: [{
        name: 'imageFilter',
        fn: function(item /*{File|FileLikeObject}*/, options) {
            var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
            return '|jpg|png|jpeg|gif|webp|'.indexOf(type) !== -1;
        }
      }]
    })

    this.uploader_banner.onAfterAddingFile = f => {
      f.withCredentials = false;

      if (this.uploader_banner.queue.length > 1) {
        this.uploader_banner.removeFromQueue(this.uploader_banner.queue[0]);
      }

      this.imageBanner = ''
      this.onChangeDetail()
    }

    this.uploader_banner.onBeforeUploadItem = (fileItem: any) => {
        fileItem.options.additionalParameter = {
          idvitrine: this.showcase.idvitrine
        };
    }

    this.uploader_banner.onCompleteItem = (item:any, response:any, status:number, headers:any) => {
      if (status == 200) {
        var responsePath = JSON.parse(response);
        if (responsePath['success']) {
          this.showcase.banner = responsePath['banner']

          this.imageBanner = AppSettings.URL_IMG_ESTABELECIMENTO + this.showcase.idestabelecimento + '/vitrine/' + this.showcase.banner
        }
      }
    }

    this.uploader_banner.onCompleteAll = () => {
      this.uploader_banner.clearQueue()
      this.num_uploads -= 1

      console.log('uploader', this.num_uploads)

      if (this.num_uploads <= 0) {
        this.saveComplete()
      }
    }

    this.uploader_banner.onErrorItem = (item:FileItem, response:any, status:any, headers:any) => {
      //console.log(item)

      item.remove()

      Swal.fire("Ops!", "Ocorreu um erro ao processar a imagem, verifique se a imagem está correta! Se é um arquivo válido de imagem (png, jpg, webp, gif) com no máximo 2 MB de tamanho", "error")
    }

    this.uploader_banner.onWhenAddingFileFailed = function (item: FileLikeObject, filter: any, options: any) {
      //console.log(item);
      //console.log(filter);
      //console.log(options);

      Swal.fire("Ops!", "O arquivo selecionado não é válido, verifique se é um arquivo de imagem (png, jpg, webp, gif) com no máximo 2 MB de tamanho!", "error")
    }
  }

  ngOnInit(): void {
    this.imageCapa = ''
    this.imageBanner = ''
    this.moveList = 0

    this.createFormControls()
    this.createForm()

    this.loading = true
    this._route.params.subscribe(data => {
      //console.log(data['codbarra'])
      if (data['id'] !== undefined) {
        this._id = data['id']
        this.getShowcaseFromId(data['id'])
      } else {
        this.loading = false
      }
    })

    this._categoryService.getAll().subscribe(data => {
      this.categories = data.categorias
      for(let j in this.categories) {
        this.categories[j].checked = false
      }

      this.checkCategoria()
    })

    this._helperService.getBrands().subscribe(data => {
      if (data['success']) {
        this.brands = data['brands']
      }
    })
  }

  onBack() {
    this.navigation.back()
  }

  createFormControls() {
    this.nome = new FormControl('', [
      Validators.required,
    ])

    this.tipo = new FormControl('P')

    this.mais_vendidos = new FormControl(false)
    this.oferta = new FormControl(false)

    this.randomico = new FormControl(false)
    this.carrossel = new FormControl(false)

    this.titulo_banner = new FormControl('')

    this.select_program = new FormControl('')

    this.diasemana = new FormControl('')

    this.diasemana_monday = new FormControl(false)
    this.diasemana_tuesday = new FormControl(false)
    this.diasemana_wednesday = new FormControl(false)
    this.diasemana_thursday = new FormControl(false)
    this.diasemana_friday = new FormControl(false)
    this.diasemana_saturday = new FormControl(false)
    this.diasemana_sunday = new FormControl(false)

    this.dt_start = new FormControl(null)
    this.dt_expired = new FormControl(null)
  }

  createForm() {
    this.showcaseFrm = new FormGroup({
      nome: this.nome,
      tipo: this.tipo,
      mais_vendidos: this.mais_vendidos,
      oferta: this.oferta,
      titulo_banner: this.titulo_banner,
      dt_start: this.dt_start,
      dt_expired: this.dt_expired,
      diasemana: this.diasemana,
      diasemana_monday: this.diasemana_monday,
      diasemana_tuesday: this.diasemana_tuesday,
      diasemana_wednesday: this.diasemana_wednesday,
      diasemana_thursday: this.diasemana_thursday,
      diasemana_friday: this.diasemana_friday,
      diasemana_saturday: this.diasemana_saturday,
      diasemana_sunday: this.diasemana_sunday,
      select_program: this.select_program,
      randomico: this.randomico,
      carrossel: this.carrossel
    })
  }

  onChangeDetail() {
    this.changeDetail = true
  }

  onChangeDays(ctl: FormControl) {
    this.diasemana_monday.setValue(false)
    this.diasemana_tuesday.setValue(false)
    this.diasemana_wednesday.setValue(false)
    this.diasemana_thursday.setValue(false)
    this.diasemana_friday.setValue(false)
    this.diasemana_saturday.setValue(false)
    this.diasemana_sunday.setValue(false)

    ctl.setValue(true)

    this.onChangeDetail()
  }

  private checkListProducts(list) {
    for(let i in list) {
      list[i]['selected'] = false
      for(let j in this.produtos) {
        if (this.produtos[j]['idproduto_geral'] == list[i]['idproduto_geral']) {
          list[i]['selected'] = true
        }
      }

      for(let j in this.produtosSelected) {
        if (this.produtosSelected[j]['idproduto_geral'] == list[i]['idproduto_geral']) {
          list[i]['selected'] = true
        }
      }
    }

    return list
  }

  onScroll() {
    if (!this.loadingProducts) {
      this.findProducts()
    }
  }

  public fileOverBase(e:any):void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverBaseBanner(e:any):void {
    this.hasBaseDropZoneBannerOver = e;
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.produtos, event.previousIndex, event.currentIndex);

    let ordem = []
    let n = 1
    for(let i in this.produtos) {
      ordem.push({
        idproduto_geral: this.produtos[i].idproduto_geral,
        ordem: n
      })
      this.produtos[i]['ordem'] = n
      ++n
    }

    this.onChangeDetail()
  }

  onRemoveFileImage(): void {
    Swal.fire({
      title: 'Você deseja excluir o banner da capa?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.uploader.clearQueue()
      }
    })
  }

  onRemoveImage(): void {
    Swal.fire({
      title: 'Você deseja excluir o banner da capa?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false
    }).then((result) => {
      if (result.value) {

        if (this.isOffer && this.imageCapa == 'auto') {
          this.imageCapa = ''
        } else {
        Swal.fire({
          title: "Excluindo...",
          icon: "info",
          showCancelButton: false,
          allowOutsideClick: false,
          showConfirmButton: false,
          heightAuto: false
        })

          this._showcaseService.removeImage(this.showcase.idvitrine, this.showcase.capa).subscribe((res) => {
            this.imageCapa = ''

            Swal.fire({
              title: "Excluido!",
              icon: "success",
              text: "O banner foi excluido",
              showCancelButton: false,
              allowOutsideClick: true,
              showConfirmButton: true,
              heightAuto: false
            })

            this.onChangeDetail()
          })
        }
      }
    })
  }

  onRemoveImageBanner(): void {
    Swal.fire({
      title: 'Você deseja excluir o banner?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false
    }).then((result) => {
      if (result.value) {

        if (this.imageBanner == '') {
          this.uploader_banner.removeFromQueue(this.uploader_banner.queue[0]);
          this.uploader_banner.clearQueue()

        } else {
          Swal.fire({
            title: "Excluindo...",
            icon: "info",
            showCancelButton: false,
            allowOutsideClick: false,
            showConfirmButton: false,
            heightAuto: false
          })

          this._showcaseService.removeBanner(this.showcase.idvitrine, this.showcase.banner).subscribe((res) => {
            this.imageBanner = ''

            Swal.fire({
              title: "Excluido!",
              icon: "success",
              text: "O banner foi excluido",
              showCancelButton: false,
              allowOutsideClick: true,
              showConfirmButton: true,
              heightAuto: false
            })

            this.onChangeDetail()
          })
        }
      }
    })
  }

  public selectProduct(product: IProduct) {
    product['selected'] = !product['selected']
    if (product['selected']) {
      this.produtosSelected.push(product)
    } else {
      let j = null
      for(let i in this.produtosSelected) {
        if (this.produtosSelected[i].idproduto_geral == product.idproduto_geral) {
          j = i
          break
        }
      }
      if (j != null){
        this.produtosSelected.splice(j, 1)
      } else {
        for(let i in this.produtos) {
          if (this.produtos[i].idproduto_geral == product.idproduto_geral) {
            j = i
            break
          }
        }
        if (j != null){
          this.produtos.splice(j, 1)
        }
      }

    }
    this.productChange = true
  }

  public onSelectFilterChange() {
    this.page = 1
    this.findProducts()
  }

  private findProducts() {
    this.query['page'] = this.page
    this.query['search'] = this.strSearch

    if (this.flCategoria) {
      this.query['idcategoria'] = this.flCategoria
    } else {
      delete this.query['idcategoria']
    }

    if (this.flMarca) {
      this.query['marca'] = this.flMarca
    } else {
      delete this.query['marca']
    }

    this.loadingProducts = true

    this._productService.search(this.query).subscribe(res => {
      if (res['success']) {
        this.products = this.checkListProducts(this.page > 1 ? this.products.concat(res.data) : res.data)

        this.page = this.page + 1

        this.loadingProducts = false
      } else {
        //error
      }
    },error => {

    })
  }

  public onChangeOrigin() {
    this.produtos = []
    this.pageSelected = 1
    this.onChangeDetail()
    this.zeroMove()

    for(let i in this.categories) {
      this.categories[i].checked = false
    }

    delete this.querySelected['in_idproduto_geral']
    delete this.querySelected['all_pages']
    delete this.querySelected['in_idcategoria']
  }

  public findListProductsCat() {
    this.produtos = []
    this.pageSelected = 1

    this.onChangeDetail()
    this.zeroMove()

    this.labelCategories = ''
    for(let i in this.categories) {
      if (this.categories[i].checked) {
        this.querySelected['in_idcategoria'].push(this.categories[i].idcategoria)

        if (this.labelCategories != '') this.labelCategories += ', '
        this.labelCategories += this.categories[i].ds_categoria
      }
    }

    if (this.querySelected['in_idcategoria'] && this.querySelected['in_idcategoria'].length == 0 && this.changeDetail == false) {
      for(let i in this.categorias) {
          this.querySelected['in_idcategoria'].push(this.categorias[i])

          if (this.labelCategories != '') this.labelCategories += ', '
          this.labelCategories += this.showcase.categorias[i].ds_categoria
      }
    }

    if (this.mais_vendidos.value) {
      this.querySelected['mais_vendidos'] = true
      this.labelCategories = 'Os mais vendidos' + (this.labelCategories != '' ? ', ' + this.labelCategories : '')
    } else {
      delete this.querySelected['mais_vendidos']
    }

    if (this.oferta.value) {
      this.querySelected['ofertas'] = true
      this.labelCategories = 'Ofertas' + (this.labelCategories != '' ? ', ' + this.labelCategories : '')
    } else {
      delete this.querySelected['ofertas']
    }

    if ((!this.querySelected['in_idcategoria'] || this.querySelected['in_idcategoria'].length == 0) && !this.querySelected['mais_vendidos'] && this.querySelected['ofertas']) {
      this.isOffer = true
      if (this.imageCapa == '') {
        this.imageCapa = 'auto'
      }
    } else {
      this.isOffer = false
      if (this.imageCapa == 'auto') {
        this.imageCapa = ''
      }
    }

    if ((this.querySelected['in_idcategoria'] && this.querySelected['in_idcategoria'].length > 0) || this.querySelected['mais_vendidos'] || this.querySelected['ofertas']) {
      this.findSelectedProducts()
    } else {
      this.labelCategories = 'Selecionar as categorias'
    }
  }

  putProducts() {
    for(let i in this.produtosSelected) {
      this.produtos.push(this.produtosSelected[i])
    }
    this.produtosSelected = []
    this.closeModalProducts()
    this.onChangeDetail()

    setTimeout(()=>{
      this.checkListProductsArrows()
    }, 400)
  }

  closeModalProducts() {
    this.openModal = false
    setTimeout(() => {
      this.showModal = false
    }, 200)
  }

  onCleanFilterMarca() {
    this.flMarca = null
  }

  onCleanFilterCategoria() {
    this.flCategoria = null
  }

  resetPageSearch() {
    this.page = 1
    this.query = { page: this.page, search: this.strSearch }

    if (this.flCategoria) {
      this.query['idcategoria'] = this.flCategoria
    } else {
      delete this.query['idcategoria']
    }

    if (this.flMarca) {
      this.query['marca'] = this.flMarca
    } else {
      delete this.query['marca']
    }

    this.loadingProducts = true

    this.searchTerm$.next(this.query)
  }

  getShowcaseFromId(id) {
    this.imageCapa = ''
    this._showcaseService.show(id).subscribe(res => {
      if (res.idvitrine) {

        this.loading = false

        this.showcase = res

        this.querySelected['idvitrine'] = this.showcase.idvitrine

        this.nome.setValue(res.nome)
        this.tipo.setValue(res.tipo)
        this.titulo_banner.setValue(res.titulo_banner)

        this.mais_vendidos.setValue(res.mais_vendidos == 'S')
        this.oferta.setValue(res.oferta == 'S')

        this.randomico.setValue(res.randomico == 'S')
        this.carrossel.setValue(res.carrossel == 'S')

        if (this.showcase.capa != null && this.showcase.capa != '' && this.showcase.capa != 'auto' && this.showcase.capa != 'no') {
          this.imageCapa = AppSettings.URL_IMG_ESTABELECIMENTO + this.showcase.idestabelecimento + '/vitrine/' + this.showcase.capa
        }

        if (this.showcase.banner != null && this.showcase.banner != '' && this.showcase.banner != 'auto' && this.showcase.banner != 'no') {
          this.imageBanner = AppSettings.URL_IMG_ESTABELECIMENTO + this.showcase.idestabelecimento + '/vitrine/' + this.showcase.banner
        }

        if (this.showcase.capa == 'no') {
          this.imageCapa = 'no'
        }

        this.diasemana.setValue(res.diasemana)
        if (res.diasemana > 0) {
          this.select_program.setValue('2')

          switch(res.diasemana) {
            case 1:
              this.diasemana_sunday.setValue(true)
              break;
            case 2:
              this.diasemana_monday.setValue(true)
              break;
            case 3:
              this.diasemana_tuesday.setValue(true)
              break;
            case 4:
              this.diasemana_wednesday.setValue(true)
              break;
            case 5:
              this.diasemana_thursday.setValue(true)
              break;
            case 6:
              this.diasemana_friday.setValue(true)
              break;
            case 7:
              this.diasemana_saturday.setValue(true)
              break;
          }
        }

        if (this.showcase.dt_inicio && this.showcase.dt_inicio != null) {
          let dtinicial = this.showcase.dt_inicio.split(' ')
          this.dt_start.setValue(AppFormat.dateYMDUTCMoment(dtinicial[0]))
        }

        if (this.showcase.dt_expiracao && this.showcase.dt_expiracao != null) {
          let dt_expired = this.showcase.dt_expiracao.split(' ')
          this.dt_expired.setValue(AppFormat.dateYMDUTCMoment(dt_expired[0]))
        }

        if (this.dt_start.value != null|| this.dt_expired.value != null) {
          this.select_program.setValue('1')
        }

        // find products

        this.pageSelected = 1

        if (res.produtos && res.produtos.length > 0) {
          this.querySelected['in_idproduto_geral'] = res.produtos
          this.querySelected['all_pages'] = true

          this.findSelectedProducts()
        } else {

          let lblCategories = ''
          this.categorias = []
          for(let i in res.categorias) {
            this.categorias.push(res.categorias[i].idcategoria);

            if (lblCategories != '') lblCategories += ', '
            lblCategories += this.showcase.categorias[i].ds_categoria
          }

          this.checkCategoria()


          if (this.categorias.length > 0) {
            this.querySelected['in_idcategoria'] = this.categorias
          }

          if (this.categorias.length > 0 || res.mais_vendidos == 'S' || res.oferta == 'S') {
            this.findListProductsCat()

            this.labelCategories = lblCategories

            if (this.mais_vendidos.value) {
              this.labelCategories = 'Os mais vendidos' + (this.labelCategories != '' ? ', ' + this.labelCategories : '')
            }
            if (this.oferta.value) {
              this.labelCategories = 'Ofertas' + (this.labelCategories != '' ? ', ' + this.labelCategories : '')
            }

          }

          if (this.categorias.length == 0 && res.mais_vendidos == 'N' && res.oferta == 'S') {
            this.isOffer = true
          }
        }
      }
      this.loading = false
    })
  }

  checkCategoria() {
    for(let i in this.categorias) {
      for(let j in this.categories) {
        if (this.categories[j].idcategoria == this.categorias[i]) {
          this.categories[j].checked = true
        }
      }
    }
  }

  private findSelectedProducts() {

    this.querySelected['page'] = this.pageSelected

    this.loadingSelectedProducts = true

    this._productService.search(this.querySelected).subscribe(res => {
      if (res['success']) {

        this.produtos = this.checkListProducts(this.pageSelected > 1 ? this.produtos.concat(res.data) : res.data)

        if (res['promotion']) {
          this.promotion = res['promotion']
        }

        this.pageSelected = this.pageSelected + 1

        this.loadingSelectedProducts = false

        setTimeout(()=>{
          this.checkListProductsArrows()
        }, 400)
      } else {
        //error
      }
    },error => {

    })
  }

  setCategory(category: ICategory, status) {
    category.checked = status
    this.querySelected['in_idcategoria'] = []
    this.findListProductsCat()
  }

  openModalProducts() {
    this.products = []
    this.produtosSelected = []
    this.showModal = true
    this.strSearch = ''
    this.onCleanFilterMarca()
    this.onCleanFilterCategoria()
    setTimeout(() => {
      this.openModal = true
    }, 200)
  }

  onRemoveProduct(product: IProduct, i: number) {
    Swal.fire({
      title: 'Você deseja remover o produto, '+product.descricao+' da vitrine?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.produtos.splice(i, 1)
        this.checkListProductsArrows()
        this.onChangeDetail()
      }
    })
  }

  checkListProductsArrows() {
    let wParent = this.listProducts.nativeElement.parentElement.clientWidth
    let w = this.listProducts.nativeElement.clientWidth

    this.arrowRight = false
    this.arrowLeft = false

    if (((this.moveList * -1) + wParent) < w) {
      this.arrowRight = true

      //loading more if needed
    }

    if (this.moveList < 0) {
      this.arrowLeft = true
    }
  }

  moveRight() {
    this.moveList += -240

    let wParent = this.listProducts.nativeElement.parentElement.clientWidth
    let w = this.listProducts.nativeElement.clientWidth
    this.listProducts.nativeElement.style.left = this.moveList + 'px'

    this.checkListProductsArrows()

    if (((this.moveList * -1) + wParent) > w) {
      if (this.tipo.value == 'C') {
        this.findSelectedProducts()
      }
    }
  }

  moveLeft() {
    this.moveList += 240

    this.listProducts.nativeElement.style.left = this.moveList + 'px'

    this.checkListProductsArrows()
  }

  zeroMove() {
    this.moveList = 0

    this.listProducts.nativeElement.style.left = this.moveList + 'px'

    this.checkListProductsArrows()
  }

  onCancelShowcase() {
    Swal.fire({
      title: 'Você deseja cancelar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.loading = true
        this.getShowcaseFromId(this.showcase.idvitrine)
      }
    })
  }

  saveError() {
    Swal.fire("Ops!", "Ocorreu um erro ao tentar salvar.", "error")
  }

  saveComplete() {
    Swal.fire("Salvo!", "A vitrine foi salva", "success")
  }

  saving() {
    Swal.fire({
      title: "Salvando...",
      icon: "info",
      showCancelButton: false,
      allowOutsideClick: false,
      showConfirmButton: false
    });
  }

  showcaseValid() {
    let has = true

    let msg = []

    if ((this.nome.invalid && (this.nome.dirty || this.nome.touched)) || this.nome.value == '' || this.nome.value == undefined  || this.nome.value == null) {
      msg.push('Você precisa preencher o nome da vitrine!');
      has = false
    }

    if ((this.tipo.invalid && (this.tipo.dirty || this.tipo.touched)) || this.tipo.value == '' || this.tipo.value == undefined  || this.tipo.value == null) {
      msg.push('Você precisa selecionar quais produtos irá expor');
      has = false
    }

    if (msg.length > 0) {
      Swal.fire("Ops!", msg.join("<br>"), "error");
    }

    return has
  }

  onSubmit() {
    if (this.showcaseValid()) {

      let data = {
        nome: this.nome.value,
        tipo: this.tipo.value,
        oferta: this.oferta.value && this.tipo.value == 'C' ? 'S' : 'N',
        mais_vendidos: this.mais_vendidos.value && this.tipo.value == 'C' ? 'S' : 'N',
        randomico: this.randomico.value ? 'S' : 'N',
        carrossel: this.carrossel.value ? 'S' : 'N'
      }

      data['categories'] = []
      if (this.tipo.value == 'C') {
        for(let i in this.categories) {
          if (this.categories[i].checked) {
            data['categories'].push(this.categories[i].idcategoria)
          }
        }
      }

      data['products'] = []
      //if (this.tipo.value == 'P') {
        for(let i in this.produtos) {
          data['products'].push(this.produtos[i].idproduto_geral)
        }
      //}

      if (this.productChange) {
        data['alteracao_produtos'] = true
      }

      if (this.isOffer && this.imageCapa == 'auto') {
          data['capa'] = 'auto'
      }

      data['diasemana'] = 0
      data['dt_inicio'] = ''
      data['dt_expiracao'] = ''

      if (this.select_program.value == 1) {
        let dtinicial = ''
        if (this.dt_start.value != null && typeof(this.dt_start.value) === 'object') {
          dtinicial = this.dt_start.value.format('YYYY-MM-DD');
        } else {
          dtinicial = this.dt_start.value
        }
        data['dt_inicio'] = dtinicial

        let dt_expiracao = ''
        if (this.dt_expired.value != null && typeof(this.dt_expired.value) === 'object') {
          dt_expiracao = this.dt_expired.value.format('YYYY-MM-DD');
        } else {
          dt_expiracao = this.dt_expired.value
        }
        data['dt_expiracao'] = dt_expiracao

      } else if (this.select_program.value == 2) {
        if (this.diasemana_monday.value) {
          data['diasemana'] = 2
        } else if (this.diasemana_tuesday.value) {
          data['diasemana'] = 3
        } else if (this.diasemana_wednesday.value) {
          data['diasemana'] = 4
        } else if (this.diasemana_thursday.value) {
          data['diasemana'] = 5
        } else if (this.diasemana_friday.value) {
          data['diasemana'] = 6
        } else if (this.diasemana_saturday.value) {
          data['diasemana'] = 7
        } else if (this.diasemana_sunday.value) {
          data['diasemana'] = 1
        }
      }

      this.saving()

      if (this.showcase != null && this.showcase.idvitrine > 0) {
        this.patchShowcase(this.showcase.idvitrine, data)
      } else {
        this.storeShowcase(data)
      }
    }

    return null
  }

  storeShowcase(data) {
    this._showcaseService.store(data).subscribe(res => {
      this.resShowcase(res)
    })
  }

  patchShowcase(id, data) {
    this._showcaseService.patch(id, data).subscribe(res => {
      this.resShowcase(res)
    })
  }

  resShowcase(res) {

    if (res['success']) {

      this.num_uploads = 0

      this.showcase = res['showcase']
      if (this.uploader.queue.length > 0 || this.uploader_banner.queue.length > 0) {

        if (this.uploader.queue.length > 0) {
          this.num_uploads += 1
        }

        if (this.uploader_banner.queue.length > 0) {
          this.num_uploads += 1
        }

        this.sendImages()

      } else {
        this.saveComplete()
      }

    } else {
      this.saveError()
    }


  }

  sendImages(): void {
    this.uploader.setOptions({
      url: this._apiService.API_PATH + 'showcase/' + this.showcase.idvitrine + '/image',
      authTokenHeader: "Authorization",
      authToken: "Bearer "+this._apiService.getAccessToken(),

    });

    this.uploader_banner.setOptions({
      url: this._apiService.API_PATH + 'showcase/' + this.showcase.idvitrine + '/banner',
      authTokenHeader: "Authorization",
      authToken: "Bearer "+this._apiService.getAccessToken(),

    });

    this.uploader.uploadAll();
    this.uploader_banner.uploadAll();
  }

}
